// API 通信层
import { SAVE_KEY, AUTH_KEY, CHAR_KEY, API_BASE } from './config.js';
import { S, save, defaultState } from './state.js';

export let authToken = localStorage.getItem(AUTH_KEY);
export let currentCharId = parseInt(localStorage.getItem(CHAR_KEY)) || 0;
export let _saveTimer = null;

export function apiHeaders() {
  const h = { 'Content-Type': 'application/json' };
  if(authToken) h['Authorization'] = `Bearer ${authToken}`;
  return h;
}

export async function apiCall(method, path, body) {
  const opts = { method, headers: apiHeaders() };
  if(body) opts.body = JSON.stringify(body);
  const resp = await fetch(API_BASE + path, opts);
  const data = await resp.json();
  if(!resp.ok) throw new Error(data.detail || '请求失败');
  return data;
}

export function setAuth(token, user) {
  authToken = token;
  localStorage.setItem(AUTH_KEY, token);
  localStorage.setItem('dnf_username', user.username);
}

export function clearAuth() {
  authToken = null; currentCharId = 0;
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(CHAR_KEY);
  localStorage.removeItem('dnf_username');
}

export function isLoggedIn() { return !!authToken; }

// 云端存档（防抖3秒）
export function cloudSave() {
  if(!currentCharId || !authToken) return;
  if(_saveTimer) clearTimeout(_saveTimer);
  _saveTimer = setTimeout(async () => {
    try {
      const state = JSON.parse(JSON.stringify(S)); // 深拷贝
      await apiCall('PUT', `/characters/${currentCharId}/save`, { state });
      const el = document.getElementById('saveIndicator');
      if(el) { el.textContent = '💾 云端已保存'; el.classList.add('show'); setTimeout(()=>el.classList.remove('show'), 1200); }
    } catch(e) { console.warn('Cloud save failed:', e.message); }
  }, 3000);
}

export function cloudSaveNow() {
  if(_saveTimer) { clearTimeout(_saveTimer); _saveTimer = null; }
  cloudSave();
}

export async function cloudLoad(charId) {
  const data = await apiCall('GET', `/characters/${charId}/load`);
  const gs = data.game_state ? (typeof data.game_state === 'string' ? JSON.parse(data.game_state) : data.game_state) : {};
  // 使用 Object.assign 保持 S 引用不变（window.S / inline S 指向同一对象）
  Object.keys(S).forEach(k => delete S[k]);
  Object.assign(S, defaultState(), gs);
  if(window.S !== S) window.S = S;
  currentCharId = charId;
  localStorage.setItem(CHAR_KEY, charId);
  localStorage.setItem(SAVE_KEY, JSON.stringify(S));
  return true;
}